// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"vgG3sN","notifications":"W8nT1C"};